import React from 'react'

class Checkbox extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            chch: this.props.value,
        }
        this.onChange = this.onChange.bind(this)
    }

    onChange(e) {
        this.setState({
            chch: e.target.checked,
        })
        this.props.onUpdate(this.props.id, { [this.props.name]: e.target.checked })
    }

    render() {
        const { label, id } = this.props
        return (
            <div className="cb-control">
                <input id={id} type="checkbox" checked={this.state.chch} onChange={this.onChange}></input>
                <label htmlFor={id} className="control_label">
                    {label}
                </label>
            </div>
        )
    }
}

export default Checkbox
